import { ILanguageItem } from "@/interface";

/**
 * @description: 获取浏览器语言
 * @return: 浏览器语言首选项 | ""
 */

export const getNavigatorLang = () => {
  const userLang = navigator.language || navigator.userLanguage;
  return userLang || "";
};

/**
 * @description: 兼容图片地址
 */

export const compatibleImgUrl = (imgUrl: string) => {
  const reg = /http|https/g;
  if (reg.test(imgUrl)) {
    return imgUrl;
  } else {
    return `${process.env.VUE_APP_ASSETS_URL}${imgUrl}`;
  }
};
